import { TranslationKey } from '@Localization';
import { ProjectRole } from '../../__legacy__/models/userRole.model';
import { Plan } from '../../__legacy__/modules/user/user.store';
import { IWorkspace, WorkspaceRole } from '../../__legacy__/modules/workspaces/workspaces.store';

export interface IPermissionCheckResult {
  allowed: boolean;
  reason?: string;
}

export function checkWorkspaceRole(roles: WorkspaceRole[], currentWorkspace: IWorkspace, t: (key: TranslationKey) => string): IPermissionCheckResult {
  const allowed = roles.includes(currentWorkspace.role);
  const reason = allowed ? undefined : t('you_do_not_have_permission_to_perform_this_operation');

  return { allowed, reason };
}

export function checkUserPlan(
  plans: Plan[],
  currentWorkspace: IWorkspace,
  t: (key: TranslationKey, options?: Record<string, string>) => string
): IPermissionCheckResult {
  const allowed = plans.includes(currentWorkspace.ownerPlanTier);
  const reason = allowed ? undefined : t('available_only_to_training_plan_users');

  return { allowed, reason };
}

export function checkpProjectRole(
  roles: ProjectRole[],
  currentProjectRole: ProjectRole | undefined,
  t: (key: TranslationKey) => string
): IPermissionCheckResult {
  const allowed = currentProjectRole ? roles.includes(currentProjectRole) : false;
  const reason = allowed ? undefined : t('you_do_not_have_permission_to_perform_this_operation');

  return { allowed, reason };
}

export function checkAll(plans: Plan[], roles: WorkspaceRole[], currentWorkspace: IWorkspace, t: (key: TranslationKey) => string): IPermissionCheckResult {
  let result = checkUserPlan(plans, currentWorkspace, t);

  if (result.allowed) {
    result = checkWorkspaceRole(roles, currentWorkspace, t);
  }

  return result;
}
